import User from "@/models/user";
import {CHAT_MEMBER_ROLE_ADMIN, CHAT_MEMBER_ROLE_CREATOR, CHAT_MEMBER_ROLE_NORMAL} from "@/constants/chat";

export default class RoomMember {

    constructor(options) {
        this._id = options?._id || 0
        this.createdAt = options?.createdAt || ""
        this.updatedAt = options?.updatedAt || ""
        this.roomId = options?.roomId || 0
        this.memberUserId = options?.memberUserId || 0
        this.memberRoleId = options?.memberRoleId || 0
        this.memberUser = new User(options?.memberUser)
    }

    get isNew() {
        return this._id <= 0
    }

    get hasSpecialRole() {
        return this.memberRoleId == CHAT_MEMBER_ROLE_ADMIN
            || this.memberRoleId == CHAT_MEMBER_ROLE_CREATOR
    }

    get isCreator() {
        return this.memberRoleId == CHAT_MEMBER_ROLE_CREATOR
    }

    get isAdmin() {
        return this.memberRoleId == CHAT_MEMBER_ROLE_ADMIN
    }

    get isMember() {
        return !this.hasSpecialRole
    }

    get getRoleName() {
        switch (this.memberRoleId) {
            case CHAT_MEMBER_ROLE_ADMIN:
                return "管理员"
            case CHAT_MEMBER_ROLE_CREATOR:
                return "创建者"
            case CHAT_MEMBER_ROLE_NORMAL:
                return "组员"
            default:
                return ""
        }
    }

    toJSON() {
        return {...this}
    }
}
